type ApiEnvelope = {
    code?: number;
    msg?: string;
    data?: unknown;
};

/** 外层 HTTP/网关成功码，或业务层成功码（如 100000） */
const SUCCESS_CODES = new Set([200, 100000]);

const isRecord = (value: unknown): value is Record<string, unknown> =>
    typeof value === 'object' && value !== null;

const isSuccessCode = (code?: number) => code != null && SUCCESS_CODES.has(code);

/** 兼容网关/代理返回：外层 code=200，真实结果在 data.body 内 */
const getNestedBody = (data: unknown): ApiEnvelope | null => {
    if (!isRecord(data) || !isRecord(data.body)) {
        return null;
    }

    const { body } = data;
    if (!('code' in body) && !('msg' in body)) {
        return null;
    }

    return body as ApiEnvelope;
};

export type ResolvedApiResult = {
    success: boolean;
    code?: number;
    msg?: string;
};

export const resolveApiResult = (response?: ApiEnvelope | null): ResolvedApiResult => {
    if (!response) {
        return { success: false, msg: 'Unknown error' };
    }

    const nestedBody = getNestedBody(response.data);
    if (nestedBody) {
        const innerCode = nestedBody.code ?? 200;
        const success = isSuccessCode(response.code) && isSuccessCode(innerCode);

        return {
            success,
            code: innerCode,
            msg: nestedBody.msg ?? response.msg,
        };
    }

    return {
        success: isSuccessCode(response.code),
        code: response.code,
        msg: response.msg,
    };
};
